import React, { useEffect } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import Tracking from 'client/utils/tracking';

const PageTracker = ({ history }: RouteComponentProps) => {
  useEffect(() => {
    Tracking.trackPage();
    history.listen(() => setTimeout(() => Tracking.trackPage(), 500));
  }, [history]);
  return <></>;
};

export default withRouter(PageTracker);
